import { Component, OnInit } from '@angular/core';
import * as Crypto from 'crypto-js'
import { LogService } from '../services/log.service';
@Component({
  selector: 'app-video-resource',
  templateUrl: './video-resource.component.html',
  styleUrls: ['./video-resource.component.css']
})
export class VideoResourceComponent implements OnInit {
  public resources = [
  //   '../../assets/y2mate.com - Matt Redman  10000 Reasons Live in Times Square_480p.mp4',
  //   '../../assets/y2mate.com - Firebase in Angular Applications  Mosh_480p.mp4',
  //   '../../assets/y2mate.com - Angular 9 CRUD with Firebase and Firestore Database  Angular 9 CRUD Tutorial_360p.mp4',
    
  ]
  public videoecrypt
  public showurl
  constructor(public log: LogService) { }

  ngOnInit() {
    this.log
      .addLog({
      action: "Access",
      component: "Video Resource",
      details: `Accessed Video Resource`,
    }).subscribe(data => { });
  }
  downLoadEncryptFile(){
    this.log
      .addLog({
      action: "Download",
      component: "Video Resource",
      details: `Downloaded Encrpyted Video Resource`,
    }).subscribe(data => { });
    this.resources.forEach(e => {
        // console.log(e); 
        this.videoecrypt= Crypto.AES.encrypt(e,'file encrypt').toString()
        this.showurl=`${this.videoecrypt}.mp4`;
        let saveFileTolocalStorage = this.videoecrypt;
        localStorage.setItem('encryptfile',JSON.stringify(saveFileTolocalStorage));
        // console.log(`${this.videoecrypt}`,this.videoecrypt.length);
    });

}
}